import { mapActions, mapState } from 'vuex'
import Actions from '@/constants/action'

export const logic = {
  data() {
    return {
      from: this.$route.query.from,
      type: this.$route.query.type,
      fullPath: this.$route.fullPath
    }
  },
  methods: {
    ...mapActions({
      updateUserInfo: Actions.UPDATE_USER_LOCAL_INFO,
      getVerifyCode: Actions.GET_VERIFY_CODE,
      loginRequest: Actions.SIMPLE_LOGIN,
      reallyAlumniLogin: Actions.REALLY_ALUMNI_LOGIN
    }),
    login(info) {
      if (this.fullPath.includes('share') || this.fullPath.includes('pick-class')) {
        this.reallyAlumniLogin(info)
          .then(() => {
            this.$router.replace({
              path: this.$route.query.redirect
            })
          })
      } else {
        this.loginRequest(info)
          .then(() => {
            this.$router.replace({
              path: this.$route.query.redirect
            })
          })
      }
    }
  },
  created() {
    console.log(this.$route)
  },
  computed: {
    ...mapState(['userInfo', 'language', 'loading']),
    cLoading() {
      return this.loading.userInfoLoading || this.loading.verifyCodeLoading // || this.loading.campaignIdLoading
    }
  }
}
